<template>
  <div 
    :class="['containerDash bg-costeaContainer overflow-auto', 
        {'extendMenu': dashboard.topBarExtendMenu}, 
        {'compressedMenu': dashboard.topBarExtendMenu == false}]">
        <transition name="page" mode="out-in">
            <router-view></router-view>
        </transition>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
    name: "Container",
    computed:{
        ...mapState(['dashboard'])
    }
}
</script>

<style>
.extendMenu{
    width: calc(100% - 12rem)
}
.compressedMenu{
    width: calc(100% - 4rem)
}
.containerDash{
    height: calc(100vh - 4rem);
}

</style>